import { create } from "zustand";
import Cookies from "js-cookie";

interface ConnectedUserState {
  firstName: string | null;
  lastName: string | null;
  setFirstName: (firstName: string | null) => void;
  setLastName: (lastName: string | null) => void;
  clear: () => void;
  logout: () => void;
}

export const useConnectedUser = create<ConnectedUserState>((set) => ({
  firstName: null,
  lastName: null,
  setFirstName: (firstName: string | null) => set({ firstName }),
  setLastName: (lastName: string | null) => set({ lastName }),
  clear: () => set({ firstName: null, lastName: null }),
  logout: () => {
    // Effacer les données utilisateur du store
    set({ firstName: null, lastName: null });
    // Supprimer le token des cookies
    Cookies.remove("token");
  },
}));
